module.exports = __webpack_public_path__ + "static/img/AL@2x.27de18ae.jpg";